module.exports = __webpack_public_path__ + "images/social-icons/twitter-icon.d15910d695de5e3be774.svg";